import type { Media } from '@/payload-types';

import Image from 'next/image';

export const BrandLogo = () => (
  <Image
    alt="Stroll"
    className="h-auto w-24 object-contain"
    height={172}
    loading="eager"
    src="/logo.webp"
    width={146}
  />
);

export const Logo = async ({ logo, businessName }: { logo: Media | null; businessName: string }) => {
  return logo?.url ? (
    <Image
      alt={businessName}
      blurDataURL={logo.blurDataUrl ?? undefined}
      className="h-auto w-20 object-contain lg:w-auto"
      height={logo.height ?? 120}
      placeholder={logo.blurDataUrl ? 'blur' : 'empty'}
      priority
      src={logo.url}
      width={logo.width ?? 120}
    />
  ) : (
    businessName
  );
};
